function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z",
  fill: "#5C0BD9"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.8 24.1V15.8H24.1",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.1 48.1999H15.8V39.8999",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.2 39.8999V48.1999H39.9",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.9 15.8H48.2V24.1",
  stroke: "white",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32 19.6001C38.8 19.6001 44.4 25.2001 44.4 32.0001C44.4 38.8001 38.8 44.4001 32 44.4001C25.2 44.4001 19.6 38.8001 19.6 32.0001C19.6 25.2001 25.2 19.6001 32 19.6001ZM32 17.6001C24 17.6001 17.6 24.0001 17.6 32.0001C17.6 40.0001 24 46.4001 32 46.4001C40 46.4001 46.4 40.0001 46.4 32.0001C46.4 24.0001 40 17.6001 32 17.6001Z",
  fill: "white"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M45.7 27.6001C43.7 28.8001 41.4 29.5001 38.9 29.5001C35 29.5001 31.5 27.8001 29.1 25.0001C26.8 28.3001 22.9 30.5001 18.6 30.5001C18.3 30.5001 18 30.5001 17.6 30.5001C18.1 25.3001 21.5 20.9001 26.1 18.8001C27.7 18.1001 29.6 17.7001 31.4 17.6001C31.6 17.6001 31.7 17.6001 31.9 17.6001C38.4 17.6001 43.8 21.8001 45.7 27.6001Z",
  fill: "white"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37 35.8999C38.1046 35.8999 39 35.0045 39 33.8999C39 32.7953 38.1046 31.8999 37 31.8999C35.8954 31.8999 35 32.7953 35 33.8999C35 35.0045 35.8954 35.8999 37 35.8999Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M27 35.8999C28.1046 35.8999 29 35.0045 29 33.8999C29 32.7953 28.1046 31.8999 27 31.8999C25.8954 31.8999 25 32.7953 25 33.8999C25 35.0045 25.8954 35.8999 27 35.8999Z",
  fill: "white"
});

var SvgFaceIcon = function SvgFaceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFaceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/face-icon.708b945c.svg";
export { ForwardRef as ReactComponent };